/** @type {import('../schema').ProcessDefinition} */
const fondos = {
  id: "fondos",
  name: "Fondos del edificio",
  category: "finanzas",
  outcome:
    "Trazabilidad del dinero por fondo (caja, reserva, fondos personalizados) y saldo mensual.",
  trigger: "Cierre aprobado; el Administrador abre Estado de cuenta / Informe.",
  actors: ["Sistema", "Administrador"],
  status: "COMPLETO",
  description:
    "Cálculo del balance mensual por fondo (saldo anterior + cobranza − gastos), registro de movimientos y saldos hacia proveedores.",
  lanes: [
    { id: "sys", actor: "Sistema" },
    { id: "admin", actor: "Administrador" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "admin",
      type: "start",
      label: "Saldos iniciales",
      description:
        "El edificio define saldo inicial de caja, reserva (UYU y USD) y fondos personalizados.",
      evidence: "src/utils/fundBalances.js",
    },
    {
      id: "s2",
      laneId: "sys",
      type: "decision",
      label: "¿El gasto tiene fondo asignado?",
      description:
        "Si no tiene fondo: default reserva para obras/multas, caja para GC.",
    },
    {
      id: "s3",
      laneId: "sys",
      type: "task",
      label: "Cálculo de balance mensual",
      description:
        "Por fondo: saldo anterior + cobranza del mes − gastos del mes. Asigna cada gasto a su fondo (sourceFund) y cada cobro según el desglose.",
      evidence: "src/utils/fundBalances.js",
    },
    {
      id: "s4",
      laneId: "sys",
      type: "document",
      label: "Movimientos",
      description:
        "Registra entradas (cobros, multas pagadas, intereses) y salidas (gastos) como traza.",
      evidence: "src/utils/fundMovements.js",
    },
    {
      id: "s5",
      laneId: "admin",
      type: "task",
      label: "Saldos de proveedores",
      description:
        "Deuda del edificio hacia cada proveedor (incluye saldos iniciales cargados).",
      evidence: "src/screens/admin/SaldosProveedoresTab.jsx",
    },
    {
      id: "s6",
      laneId: "admin",
      type: "task",
      label: "Revisión de reportes",
      description:
        "El Administrador revisa el balance por fondo y los saldos de proveedores.",
    },
    {
      id: "s7",
      laneId: "sys",
      type: "end",
      label: "Trazabilidad por fondo lista",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "Fondo asignado" },
    { from: "s2", to: "s3", label: "Default por tipo de gasto" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
  ],
};
export default fondos;
